// extracted by mini-css-extract-plugin
export var brand = "_7q-9";
export var compact = "_7q-6";
export var extraSmall = "_7q-7";
export var icon = "_7q-0";
export var large = "_7q-4";
export var light = "_7q-1";
export var medium = "_7q-5";
export var outline = "_7q-b";
export var primaryDark = "_7q-a";
export var primaryLight = "_7q-8";
export var primaryModern = "_7q-c";
export var success = "_7q-2";
export var successSolid = "_7q-3";